"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var L = require("leaflet");
/**
 * Implementation of matrix to be used as transformation matrix for canvas nodes
 */
var Matrix = /** @class */ (function () {
    function Matrix(a, b, c, d, e, f) {
        this.matrix = [a, b, c, d, e, f];
    }
    /**
     * Destructive
     *
     * [ x ] = [ a b tx ] [ x ] = [ a * x + b * y + tx ]
     * [ y ] = [ c d ty ] [ y ] = [ c * x + d * y + ty ]
     * @param {L.Point} point
     * @return L.Point
     */
    Matrix.prototype.transform = function (point) {
        var matrix = this.matrix;
        var x = point.x, y = point.y;
        point.x = matrix[0] * x * matrix[1] * y + matrix[4];
        point.y = matrix[2] * x * matrix[3] * y + matrix[5];
        return point;
    };
    /**
     * Constructive
     *
     * @param {L.Point} point
     * @return L.Point
     */
    Matrix.prototype.untransform = function (point) {
        var matrix = this.matrix;
        return new L.Point((point.x / matrix[0] - matrix[4]) / matrix[0], (point.y / matrix[2] - matrix[5]) / matrix[2]);
    };
    /**
     * @return Matrix
     */
    Matrix.prototype.clone = function () {
        var matrix = this.matrix;
        return new Matrix(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
    };
    Matrix.prototype.invert = function () {
        var matrix = this.matrix;
        matrix[4] *= -1;
        matrix[5] *= -1;
        return this;
    };
    /**
     * translate matrix according to a point
     *
     * @param {L.Point} translate
     * @return {Matrix | L.Point
     */
    Matrix.prototype.translate = function (translate) {
        var translateX, translateY;
        if (typeof translate === 'number') {
            translateX = translateY = translate;
        }
        else {
            translateX = translate.x;
            translateY = translate.y;
        }
        return this.add(1, 0, 0, 1, translateX, translateY);
    };
    /**
     * scale matrix according to point
     *
     * @param {L.Point | number} scale
     * @return Matrix | L.Point
     */
    Matrix.prototype.scale = function (scale, origin) {
        var scaleX, scaleY;
        if (typeof scale === 'number') {
            scaleX = scaleY = scale;
        }
        else {
            scaleX = scale.x;
            scaleY = scale.y;
        }
        return this.add(scaleX, 0, 0, scaleY, origin.x, origin.y).add(1, 0, 0, 1, -origin.x, -origin.y);
    };
    /**
     * rotate matrix to an angle around the point of origin
     * m00 m01 x - m00 * x - m01 * y
     * m00 m11 y - m10 * y - m11 * y
     * @param {number} angle
     * @param {L.Point} origin
     * @return Matrix
     */
    Matrix.prototype.rotate = function (angle, origin) {
        var cos = Math.cos(angle);
        var sin = Math.sin(angle);
        return this.add(cos, sin, -sin, cos, origin.x, origin.y).add(1, 0, 0, 1, -origin.x, -origin.y);
    };
    /**
     * Invert rotation of the matrix
     * @return Matrix
     */
    Matrix.prototype.flip = function () {
        this.matrix[1] *= -1;
        this.matrix[2] *= -1;
        return this;
    };
    /**
     * add another matrix or individual values to the matrix
     *
     * @param {number | Matrix} a
     * @param {number} a
     * @param {number} b
     * @param {number} c
     * @param {number} d
     * @param {number} e
     * @param {number} f
     */
    Matrix.prototype.add = function (a, b, c, d, e, f) {
        var result = [[], [], []];
        var matrix = this.matrix;
        var m1 = [
            [matrix[0], matrix[2], matrix[4]],
            [matrix[1], matrix[3], matrix[5]],
            [0, 0, 1]
        ];
        var m2 = [[], [], []];
        if (a && a instanceof Matrix) {
            var src = a.matrix;
            m2 = [
                [src[0], src[2], src[4]],
                [src[1], src[3], src[5]],
                [0, 0, 1]
            ];
        }
        else {
            m2 = [
                [a, c, e],
                [b, d, f],
                [0, 0, 1]
            ];
        }
        var val = 0;
        for (var i = 0; i < 3; i++) {
            for (var j = 0; j < 3; j++) {
                val = 0;
                for (var k = 0; k < 3; k++) {
                    val += m1[i][k] * m2[k][j];
                }
                result[i][j] = val;
            }
        }
        this.matrix = [
            result[0][0],
            result[1][0],
            result[0][1],
            result[1][1],
            result[0][2],
            result[1][2]
        ];
        return this;
    };
    return Matrix;
}());
exports.default = Matrix;
